export default "__VITE_ASSET__2SBxnFvw__"